import { render } from "./Clerk.vue?vue&type=template&id=cea73f76&scoped=true"
import script from "./Clerk.vue?vue&type=script&lang=js"
export * from "./Clerk.vue?vue&type=script&lang=js"

import "./Clerk.vue?vue&type=style&index=0&id=cea73f76&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea73f76"]])

export default __exports__